import { DICT_LANGUAGE } from 'src/utils/constant'

export const getEmptyDef = word => {
	return {
		[DICT_LANGUAGE.VI]: [],
		[DICT_LANGUAGE.EN]: [],
		term: word,
		spelling: '',
		spellingUk: '',
	}
}

/**
 * Walks admin `en` wordTypes / termWordTypes and collects examples tied to meanings,
 * tagging them with wordMeaningID + dictWordID for the "More examples" tab.
 */
function collectExamplesFromEnglishWordTypes(wordTypes, dictWordId, out) {
	if (!Array.isArray(wordTypes)) {
		return
	}
	wordTypes.forEach(wt => {
		;(wt.meanings || []).forEach(m => {
			;(m.examples || []).forEach(ex => {
				if (ex && ex.id != null) {
					out.push({
						...ex,
						wordMeaningID: m.id,
						dictWordID: dictWordId,
					})
				}
			})
		})
	})
}

/**
 * Deep clone English definition and clear examples on every meaning so they are not
 * duplicated under the English tab (they are merged into dictWord.moreExamples).
 */
export function stripEnglishMeaningExamples(en) {
	if (!en || typeof en !== 'object') {
		return en
	}
	const clone = JSON.parse(JSON.stringify(en))
	;[clone.wordTypes, clone.termWordTypes].forEach(wordTypes => {
		if (!Array.isArray(wordTypes)) {
			return
		}
		wordTypes.forEach(wt => {
			;(wt.meanings || []).forEach(m => {
				m.examples = []
			})
		})
	})
	return clone
}

/**
 * Admin API returns meaning-linked examples under `en` and unattached rows in `moreExamples`.
 * The modal reads more examples only from `dictWord.moreExamples`, so we merge and strip `en`.
 */
export function normalizeAdminDictLookupResponse(result) {
	if (!result || typeof result !== 'object') {
		return result
	}
	const { vi, en, ...dictWord } = result
	const dictWordId = dictWord.id

	const fromAPI = Array.isArray(dictWord.moreExamples)
		? dictWord.moreExamples.map(ex => ({
				...ex,
				dictWordID: ex.dictWordID ?? dictWordId,
			}))
		: []

	const fromMeanings = []
	collectExamplesFromEnglishWordTypes(en?.wordTypes, dictWordId, fromMeanings)
	collectExamplesFromEnglishWordTypes(en?.termWordTypes, dictWordId, fromMeanings)

	const seen = new Set()
	const merged = []
	fromAPI.forEach(ex => {
		if (ex?.id != null && !seen.has(ex.id)) {
			seen.add(ex.id)
			merged.push(ex)
		}
	})
	fromMeanings.forEach(ex => {
		if (ex?.id != null && !seen.has(ex.id)) {
			seen.add(ex.id)
			merged.push(ex)
		}
	})

	return {
		vi,
		en: stripEnglishMeaningExamples(en),
		dictWord: {
			...dictWord,
			moreExamples: merged,
		},
	}
}
